import { rutinInfos } from '../../_Common/Const/RutinInfo';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../../_Common/Components/ListRutin/ListRutin';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const GARutiner = {
  rtnWebGrav: {
    component: getStandardRutin(rutinInfos.rtnWebGrav, 'GAGrav'),
  },
  rtnGravsatta: {
    component: getStandardRutin(rutinInfos.rtnGravsatta, 'GAGravsatt'),
  },
  rtnKontakter: {
    component: getStandardRutin(rutinInfos.rtnKontakter, 'GAKontakt'),
  },
  rtnSkotselExport: {
    component: getStandardRutin(rutinInfos.rtnSkotselExport, 'GASkotsel'),
  },
  rtnGravHandelseLogg: {
    component: getStandardRutin(rutinInfos.rtnGravHandelseLogg, 'GAHandelse'),
  },
  rtnGravMyCartaUrval: {
    component: getStandardRutin(
      rutinInfos.rtnGravMyCartaUrval,
      'GAMyCartaUrval'
    ),
  },
  rtnGravKartaTeman: {
    component: getStandardRutin(rutinInfos.rtnGravKartaTeman, 'GAKartaTema'),
  },
  rtnSkotselFakt: {
    component: withAddStartedRoutine(rutinInfos.rtnSkotselFakt)(
      createListRutin(
        'GASkotsel',
        [
          { attributeDef: 'Grav.Gravnr', caption: 'Gravnummer' },
          { attributeDef: 'Ar', caption: '' },
          { attributeDef: 'MANAD', caption: 'Mån' },
          { attributeDef: 'Artikel.ARTIKELNR', caption: 'Artikel' },
          { attributeDef: 'BenamningShort', caption: 'Benämning' },
          { attributeDef: 'DebsattNrNamn', caption: 'Debiteringssätt' },
          { attributeDef: 'AntalEnhet', caption: 'Antal' },
          { attributeDef: 'PrisSQL', caption: 'Pris' },
          { attributeDef: 'BeloppSQL', caption: 'Belopp' },
          { attributeDef: 'FelOrsak', caption: 'Felorsak' },
        ],
        notImplemented('FaktureraGravskotsel DetailComp')
      )
    ), // OrderOmgSkapa
  },
  rtnAvtalFakt: {
    component: withAddStartedRoutine(rutinInfos.rtnAvtalFakt)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Avtalsnr' },
          { attributeDef: 'OrgPers.Namn', caption: 'Namn' },
          { attributeDef: 'OrgPers.OrgNrPersNr', caption: 'Orgnr/Persnr' },
          { attributeDef: 'TYP', caption: 'Avtalstyp' },
          { attributeDef: 'Avtalsbelopp2', caption: 'Avtalsbelopp' },
          { attributeDef: 'Avtalsperiod', caption: '' },
          { attributeDef: 'KundkategoriKodBen', caption: '' },
          { attributeDef: 'GravNrBetAnsv', caption: '' },
        ],
        notImplemented('FaktureraGravskotselavtal DetailComp')
      )
    ),
  },
  rtnBestallningsOrder: {
    component: withAddStartedRoutine(rutinInfos.rtnBestallningsOrder)(
      createListRutin(
        'GASkotsel',
        [
          { attributeDef: 'Grav.Gravnr', caption: 'Gravnummer' },
          { attributeDef: 'Ar', caption: '' },
          { attributeDef: 'MANAD', caption: 'Mån' },
          { attributeDef: 'Artikel.ARTIKELNR', caption: 'Artikel' },
          { attributeDef: 'BenamningShort', caption: 'Benämning' },
          { attributeDef: 'DebsattNrNamn', caption: 'Debiteringssätt' },
          { attributeDef: 'AntalEnhet', caption: 'Antal' },
          { attributeDef: 'PrisSQL', caption: 'Pris' },
          { attributeDef: 'BeloppSQL', caption: 'Belopp' },
          { attributeDef: 'FelOrsak', caption: 'Felorsak' },
        ],
        notImplemented('SkapaBestallningsorder DetailComp')
      )
    ), // OrderOmgSkapa
  },
  rtnArbetsunderlagSkapa: {
    component: withAddStartedRoutine(rutinInfos.rtnArbetsunderlagSkapa)(
      createListRutin(
        'GASkotsel',
        [
          { attributeDef: 'Grav.GravNr', caption: 'Gravnummer' },
          { attributeDef: 'MANAD', caption: 'Mån.' },
          { attributeDef: 'Artikel.Artikelnr', caption: 'Artikel' },
          { attributeDef: 'BenamningShort', caption: 'Benämning' },
          { attributeDef: 'AntalEnhet', caption: 'Antal' },
          { attributeDef: 'PrisSQL', caption: 'Pris' },
          { attributeDef: 'BeloppSQL', caption: 'Belopp' },
        ],
        notImplemented('SkapaArbetsunderlag DetailComp')
      )
    ),
  },
  rtnArbetsunderlag: {
    component: getStandardRutin(rutinInfos.rtnArbetsunderlag, 'GAArbUnd'),
  },
  rtnFasttidsavtalUppr: {
    component: withAddStartedRoutine(rutinInfos.rtnFasttidsavtalUppr)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Avtalsnummer' },
          { attributeDef: 'Namn', caption: 'Namn ' },
          { attributeDef: 'UPPLAGGNINGS_DATUM', caption: 'Uppläggn.datum' },
          { attributeDef: 'Avtalsperiod', caption: '' },
          { attributeDef: 'AVTALSBELOPP', caption: 'Avtalsbelopp' },
          { attributeDef: 'Restbelopp', caption: '' },
          { attributeDef: 'Upprakningsbelopp', caption: 'Uppräkn.belopp' },
          { attributeDef: 'FelOrsak', caption: 'Felorsak' },
          { attributeDef: 'FelSortering', caption: 'Sortering' },
        ],
        notImplemented('UppraknaFasttidsavtal DetailComp')
      )
    ),
  },
  rtnAvrakningsavtAvr: {
    component: withAddStartedRoutine(rutinInfos.rtnAvrakningsavtAvr)(
      createListRutin(
        'GASkotsel',
        [
          { attributeDef: 'Grav.Gravnr', caption: 'Gravnummer' },
          { attributeDef: 'Ar', caption: '' },
          { attributeDef: 'MANAD', caption: 'Mån' },
          { attributeDef: 'Artikel.ARTIKELNR', caption: 'Artikel' },
          { attributeDef: 'BenamningShort', caption: 'Benämning' },
          { attributeDef: 'DebsattNrNamn', caption: 'Debiteringssätt' },
          { attributeDef: 'AntalEnhet', caption: 'Antal' },
          { attributeDef: 'PrisSQL', caption: 'Pris' },
          { attributeDef: 'BeloppSQL', caption: 'Belopp' },
          { attributeDef: 'FelOrsak', caption: 'Felorsak' },
        ],
        notImplemented('AvraknaAvrakningsavtal DetailComp')
      )
    ), // EDFOrderOmgSkapa
  },
  rtnAvrakningsavtKalk: {
    component: withAddStartedRoutine(rutinInfos.rtnAvrakningsavtKalk)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Avtalsnummer' },
          { attributeDef: 'Namn', caption: 'Namn (efternamn, förnamn)' },
          { attributeDef: 'Avtalsperiod', caption: 'Period' },
          { attributeDef: 'BeraknatAtagande', caption: 'Beräknat åtagande' },
          { attributeDef: 'KontosaldoAktuellt', caption: 'Kontosaldo' },
          { attributeDef: 'Garantiskuld', caption: 'Garantiskuld' },
          { attributeDef: 'FelOrsak', caption: 'Felorsak' },
        ],
        notImplemented('GarantiatagandeAvrakningsavtal DetailComp')
      )
    ),
  },
  rtnUtgaendeSkotsel: {
    component: withAddStartedRoutine(rutinInfos.rtnUtgaendeSkotsel)(
      createListRutin(
        'KRKund',
        [
          { attributeDef: 'KUNDNR_KONTONR', caption: 'Avtalsnr' },
          { attributeDef: 'OrgPers.Namn', caption: 'Namn' },
          { attributeDef: 'OrgPers.OrgNrPersNr', caption: 'Orgnr/Persnr' },
          { attributeDef: 'TYP', caption: 'Avtalstyp' },
          { attributeDef: 'Kundkategori.BENAMNING', caption: 'Kundkategori' },
          { attributeDef: 'Avtalsperiod', caption: '' },
          { attributeDef: 'GravNrBetAnsv', caption: '' },
        ],
        notImplemented('HanteraUtgaendeAvtal DetailComp')
      )
    ),
  },
  rtnFaktura: {
    component: withAddStartedRoutine(rutinInfos.rtnFaktura)(
      createListRutin(
        'OFOrder',
        [
          { attributeDef: 'Kund.KUNDNR_KONTONR', caption: 'Kundnr/Kontonr' },
          { attributeDef: 'NAMN', caption: 'Kund' },
          { attributeDef: 'SAMFAKTURERAS', caption: 'Samfakt.' },
          { attributeDef: 'ORDERNR', caption: 'Ordernr' },
          { attributeDef: 'ORDERDATUM', caption: 'Datum' },
          { attributeDef: 'MOMS', caption: 'Moms' },
          { attributeDef: 'TotBelopp', caption: 'Orderbelopp' },
          { attributeDef: 'TotFakturaBelopp', caption: 'Belopp att fakt.' },
          { attributeDef: 'TotOrderMoms', caption: 'Ordermoms' },
          { attributeDef: 'TotFakturaMoms', caption: 'Fakturamoms' },
          { attributeDef: 'ORDER_OMG', caption: 'Orderomg' },
          { attributeDef: 'AntalBilagor', caption: '' },
          { attributeDef: 'FAKTURATEXT', caption: '' },
          { attributeDef: 'Kund.Bank.CLEARINGNR', caption: 'Clearingnr' },
          { attributeDef: 'Kund.BANKKONTONUMMER', caption: 'Bankkontonr' },
          { attributeDef: 'FAKTURA_NR', caption: 'Fakturanr' },
        ],
        notImplemented('Fakturerings detailcomp')
      )
    ),
  },
  rtnSkotselKategorier: {
    component: getStandardRutin(
      rutinInfos.rtnSkotselKategorier,
      'GASkotselKategori'
    ),
  },
  rtnSkotselBestallningar: {
    component: getStandardRutin(
      rutinInfos.rtnSkotselBestallningar,
      'GASkotselBest'
    ),
  },
  rtnOrderOmg: {
    component: getStandardRutin(rutinInfos.rtnOrderOmg, 'GAOrderOmg'),
  },
  rtnInformationskiosk: {
    component: getStandardRutin(rutinInfos.rtnInformationskiosk, 'GAInfokiosk'),
  },

  //////////////////////////////////
  // KJ
  //////////////////////////////////
  rtnKremationsjournal: {
    component: getStandardRutin(rutinInfos.rtnKremationsjournal, 'KJKremation'),
  },

  rtnAktuellaKremationer: {
    component: getStandardRutin(
      rutinInfos.rtnAktuellaKremationer,
      'BOBisattning'
    ),
  },
};

export default GARutiner;
